var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"app-header"},[(_vm.xmasEventStarted && _vm.showsXmasHeader)?_c('XmasHeader'):_vm._e(),(_vm.showsReisereporterHeader)?_c('ReisereporterHeader'):_vm._e(),(_vm.showsTopNav)?_c('TopNavigation',{attrs:{"template-type":_vm.templateType}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }